import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SnapshotModel } from '../models';
import { HttpService } from '../services/http.service';

@Injectable()
export class SnapshotsService {
    private httpService = inject(HttpService);

    snapshots$ = new BehaviorSubject<SnapshotModel[] | null>(null);

    private subscription = new Subscription();

    dispatch(): void {
        this.subscription.add(
            this.httpService
                .getSnapshots()
                .pipe(tap((snapshots) => this.snapshots$.next(snapshots)))
                .subscribe(),
        );
    }

    destroy(): void {
        this.subscription.unsubscribe();
    }
}
